/**
 * Idioma del sitio web público. Inglés por omisión; la persona cambia a español con el
 * botón del menú y queda recordado en el navegador. (Las pantallas de acceso tienen su
 * propio idioma, español por omisión: `utils/idiomaAcceso.js`.)
 */
import { create } from 'zustand';
import TEXTOS from './textos';

const CLAVE = 'f360-idioma-sitio';
const leer = () => { try { return localStorage.getItem(CLAVE) === 'es' ? 'es' : 'en'; } catch { return 'en'; } };

export const useIdiomaSitio = create((set) => ({
  idioma: leer(),
  cambiar: (idioma) => {
    try { localStorage.setItem(CLAVE, idioma); } catch { /* sin almacenamiento */ }
    document.documentElement.lang = idioma;
    set({ idioma });
  },
}));

export function useT() {
  const idioma = useIdiomaSitio(s => s.idioma);
  return TEXTOS[idioma];
}
